import { colors } from '../../foundation';

type Props = {
  variant?: 'classic' | 'inverted';
  width?: 270 | 60 | 50 | 45 | 24;
  height?: 168 | 28 | 24 | 20;
  isLoading?: boolean;
};

const LogoEye = ({ variant = 'classic', width = 45, height = 28, isLoading = false }: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 45 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14078_73369)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.6154 25.4121C44.4781 25.5494 44.3074 25.6279 44.1039 25.6485L43.6457 25.6498C42.7731 25.6521 41.9005 25.6544 41.0279 25.6544C40.0537 25.6544 39.2205 25.6514 38.4374 25.6454C38.2466 25.6204 38.0856 25.5427 37.9548 25.4121C37.8232 25.2803 37.745 25.1173 37.721 24.9233C37.7871 22.0348 37.2783 19.4397 36.2075 17.2017C34.2564 12.9279 30.2581 9.63871 25.7752 8.62198C24.6674 8.36426 23.5189 8.23329 22.3636 8.23329C20.0838 8.23329 17.8233 8.74889 15.8263 9.72434C12.8726 11.1426 10.3926 13.5592 8.84499 16.5283C7.63896 18.8167 7.00474 21.4727 7.01173 24.208C7.00767 24.3498 7.00896 24.5132 7.01091 24.6776C7.0114 24.7169 7.01189 24.7605 7.01221 24.8063H7.00978C7.00604 25.0525 6.92495 25.2546 6.76766 25.4121C6.62759 25.552 6.45291 25.6311 6.24394 25.65C5.20105 25.6516 4.16417 25.6527 3.12729 25.6527C2.29548 25.6527 1.46351 25.6519 0.631371 25.65C0.422078 25.6313 0.24723 25.5521 0.106997 25.4121C-0.0190986 25.286 -0.0961183 25.131 -0.123742 24.9477C-0.339698 19.3296 1.52379 13.6847 5.02799 9.38765C8.89585 4.55019 14.8009 1.43695 20.8262 1.05801C21.3504 1.0195 21.8761 1 22.3915 1C26.3891 1 30.3079 2.09603 33.7241 4.16962C37.9171 6.68602 41.2512 10.595 43.1138 15.177C44.3431 18.1606 44.9403 21.5169 44.8506 24.9131C44.828 25.1115 44.7495 25.278 44.6154 25.4121ZM28.1965 21.5852C28.1965 24.8095 25.5826 27.4234 22.3582 27.4234C19.1338 27.4234 16.5199 24.8095 16.5199 21.5852C16.5199 18.3608 19.1338 15.7469 22.3582 15.7469C25.5826 15.7469 28.1965 18.3608 28.1965 21.5852Z"
          fill={variant === 'classic' ? colors.primary.red : colors.primary.white}
        >
          {isLoading && (
            <>
              <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" repeatCount="indefinite" />
              <animate
                attributeName="transform"
                attributeType="XML"
                type="scale"
                values="1;1.1;1"
                begin="0s"
                dur="2s"
                repeatCount="indefinite"
              />
            </>
          )}
        </path>
      </g>
      <defs>
        <clipPath id="clip0_14078_73369">
          <rect width="45" height="28" fill={variant === 'classic' ? colors.primary.red : colors.primary.white} />
        </clipPath>
      </defs>
    </svg>
  );
};
export default LogoEye;
